import * as React from "react";
import MuiContainer from "components/MuiExtras/MuiContainer";
import { Typography } from "@mui/material";

interface IProps {
    text: string
}

type Props = IProps;

const FormSubtitle: React.FC<Props> = (props) => {

    if (props.text == null)
        return null;

    return (
        <MuiContainer margin="dense">
            <Typography color="secondary" variant="overline"><b>{props.text}</b></Typography>
        </MuiContainer>
    );
}


export default FormSubtitle;
